export function getGradeColor(grade) {
  if (typeof grade !== 'string' || !grade.trim()) return 'gray';
  const g = grade.trim().toLowerCase();
  if (g.startsWith('6a') || g.startsWith('6a+') || g.startsWith('6b')) return 'yellow'; // 6a, 6a+, 6b
  if (g.startsWith('6b+') || g.startsWith('6c') || g.startsWith('6c+')) return 'red';   // 6b+, 6c, 6c+
  if (g.startsWith('7a') || g.startsWith('7a+') || g.startsWith('7b')) return 'black';  // 7a, 7a+, 7b
  if (g.startsWith('7b+') || g.startsWith('7c') || g.startsWith('7c+')) return 'pink';  // 7b+, 7c, 7c+
  if (g.startsWith('8a') || g.startsWith('8a+') || g.startsWith('8b')) return 'brown';  // 8a, 8a+, 8b
  // Add more if needed
  return 'gray';
}